import { useNavigate, useSearch } from '@tanstack/react-router';
import { useState, type JSX } from 'react';
import { readParametresSearch } from './search-params.js';
import { StoreDetailForm } from './store-detail-form.js';
import { StoreInstallSheet } from './store-install-sheet.js';
import { StoreList } from './store-list.js';

/**
 * Onglet Boutiques — `02` §12.2. Liste et fiche tiennent dans une seule route
 * (`/parametres`) : le drill-down est purement client-side, piloté par le
 * paramètre d'URL `store` (voir `README-shell.md`). `store` absent → liste ;
 * sinon → fiche boutique.
 *
 * Plus de formulaire de création (décision du 10/09/2026) : « Installer une
 * boutique » ouvre un tiroir qui redirige vers Shopify, et la boutique naît du
 * callback OAuth.
 */
export function BoutiquesTab(): JSX.Element {
  const rawSearch: unknown = useSearch({ strict: false });
  const navigate = useNavigate();
  const { store } = readParametresSearch(rawSearch);
  const [installOpen, setInstallOpen] = useState(false);

  function setStore(next: string | undefined): void {
    void navigate({
      to: '.',
      search: (prev: Record<string, unknown>) => ({ ...prev, store: next }),
      replace: true,
    });
  }

  if (store) {
    return (
      <StoreDetailForm
        code={store}
        onBack={() => {
          setStore(undefined);
        }}
      />
    );
  }

  return (
    <>
      <StoreList
        onSelect={(code) => {
          setStore(code);
        }}
        onAddNew={() => {
          setInstallOpen(true);
        }}
      />
      <StoreInstallSheet open={installOpen} onOpenChange={setInstallOpen} />
    </>
  );
}
